<template>
  <section>
    <form action>
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-title">{{headerText}}</p>
        </header>
        <section class="modal-card-body">
          <b-field label="Nickname">
            <b-select placeholder="Select a name" v-model="nicknameValue" :disabled="formMode !== 'create'" required>
              <option v-for="n in nicknameList" :value="n" :key="n">{{ n }}</option>
            </b-select>
          </b-field>

          <b-field label="Monate eintragen (Mehrauswahl möglich)">
            <b-select multiple expanded native-size="5" v-model="selectedMonthNames" required>
              <option v-for="m in monthNames" :value="m" :key="m.key">{{ m.name }}</option>
            </b-select>
          </b-field>
        </section>

        <footer class="modal-card-foot">
          <button class="button" type="button" @click="$parent.close()">Abbrechen</button>
          <button class="button is-success" type="button" @click="saveSchedule()">Speichern</button>
        </footer>
      </div>
    </form>
  </section>
</template>

<script>
import Store from "../store";
import moment from "moment";

export default {
  name: "editScheduleForm",
  props: ["nickname", "milkSchedule", "formMode"],
  data() {
    return {
      headerText: "Milchliste",
      nicknameValue: "",
      monthNames: [],
      selectedMonthNames: []
    };
  },
  computed: {
    nicknameList() {
      return Store.state.coffees.map(e => e.nickname);
    }
  },
  methods: {
    saveSchedule: async function() {
     await Store.dispatch("updateMilkSchedule", {
        nickname: this.nicknameValue,
        months: this.selectedMonthNames.map( m => m.key)
      });
      this.$parent.close();
    },
    getMonthNames: function() {
      return Array(12)
        .fill()
        .map((x, i) => {
          return {
            key: i + 1,
            name: moment(i + 1, "MM").format("MMMM")
          };
        });
    },
    getSelection(nums) {
    const names = this.getMonthNames();
      if (nums) {
        return nums.map( num => names.find( name => name.key === num ) ) 
      } else {
        return [];
      }
    },
  },
  mounted() { 
    this.monthNames = this.getMonthNames();
    this.selectedMonthNames = this.getSelection(this.milkSchedule)
    this.nicknameValue = this.nickname;
    this.headerText = "Monate eintragen";
  }
};
</script>


<style>
</style>
